import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserCityBuilderGame from 'src/games/CityBuilderGame/Main';

interface CityBuilderGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class CityBuilderGame extends React.Component<CityBuilderGameProps> {
    constructor(props: CityBuilderGameProps) {
        super(props);
        bindAllOfThis(this, CityBuilderGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserCityBuilderGame onComplete={this.completeGame} />
        </div>;
    }
}

export default CityBuilderGame;



// WEBPACK FOOTER //
// ./src/pages/game/CityBuilderGame.tsx